import { combineReducers } from "redux";

import icons from "js/react/views/icons/reducers/iconsReducers";
// import {commonReducer} from "js/react/views/old/common/reducer";
import navigation from "js/react/views/Nav/nav_reducer";
import theme from "js/react/views/ThemeEditor/reducers/themeEditor_reducer";

export const reducers = () => {
    return combineReducers({
        // Add reducers here
        icons: icons(),
        // commonReducer,
        navigation,
        theme
    });
};

export default reducers;
